import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const SESSION_KEY = 'unaavu_analytics_session';

export type FunnelJourney = 'order' | 'reservation';

@Injectable({ providedIn: 'root' })
export class JourneyAnalyticsService {
  private readonly http = inject(HttpClient);
  private readonly endpoint = `${environment.apiBaseUrl}/analytics/events`;
  private readonly sent = new Set<string>();

  track(journey: FunnelJourney, step: string, customerId?: string | null): void {
    if (typeof window === 'undefined') {
      return;
    }
    const sessionId = this.sessionId();
    const key = `${journey}:${step}:${sessionId}`;
    if (this.sent.has(key)) {
      return;
    }
    this.sent.add(key);
    this.http
      .post(this.endpoint, {
        journey,
        step,
        sessionId,
        ...(customerId ? { customerId } : {}),
      })
      .subscribe({ error: () => undefined });
  }

  private sessionId(): string {
    try {
      const existing = sessionStorage.getItem(SESSION_KEY);
      if (existing && existing.length >= 8) {
        return existing;
      }
      const created =
        typeof crypto !== 'undefined' && 'randomUUID' in crypto
          ? crypto.randomUUID()
          : `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(SESSION_KEY, created);
      return created;
    } catch {
      return `s_${Date.now()}`;
    }
  }
}
